import type { z } from 'zod';

import { EmployeeContractHistory } from '../core/employee-contract-history';

export const EmployeeContractHistoryFormData = EmployeeContractHistory;
export type EmployeeContractHistoryFormDataType = z.infer<typeof EmployeeContractHistoryFormData>;
